// Import the functions you need from the SDKs you need
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
  apiKey: "AIzaSyBIVaVrLNM_8d0qN1HCQsdzCrmUg2hE0gs",
  authDomain: "mascraper.firebaseapp.com",
  projectId: "mascraper",
  storageBucket: "mascraper.appspot.com",
  messagingSenderId: "363270132536",
  appId: "1:363270132536:web:4f30b10a7e38600767a7cd",
  measurementId: "G-Q8SHM4LT5E"
};

// Initialize Firebase
const app = initializeApp(config);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestore = getFirestore(app);

export { analytics, auth, config, firestore };

